
import { defineComponent, reactive } from "vue";

// State object.
interface State {
  title: string;
  numberOfPhoto: number;
  currentIndex: number;
  isShow: boolean;
}

// Component definition
export default defineComponent({
  name: "PhotoDescription",
  setup() {
    // state object.
    const state = reactive<State>({
      title: "",
      numberOfPhoto: 0,
      currentIndex: 0,
      isShow: false
    });

    // setup project.
    const show = (title: string, numberOfPhoto: number) => {
      if (state.title !== title) {
        state.title = title;
        state.numberOfPhoto = numberOfPhoto;
        state.currentIndex = 1;
      }
      state.isShow = true;
    };

    // update the current index.
    const update = (currentIndex: number) => {
      state.currentIndex = currentIndex;
      state.isShow = true;
    };

    return {
      show,
      update,
      state
    };
  }
});
